<script setup>
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {getCurrentInstance, reactive} from "vue";
const { $alert } = getCurrentInstance().appContext.config.globalProperties;
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const router = useRouter()
const store = useStore()
const filterData = store.getters["booking_filter/getRoomFilter"]
const roomChoose = store.getters["room/getRoomChoose"]
const bookForm = reactive({
  arrival:filterData?.arrival??'',
  departure:filterData?.departure??'',
  guest:filterData?.guest??'',
  type_appart:filterData?.type_appart??{}
})
const formValidator = ()=>
{
  return (bookForm.guest > 0 && bookForm.arrival.length > 5 && bookForm.departure.length > 5)
}
function bookApartment(){
  if (formValidator()){
    const roomCheckInfos = {...bookForm, roomId:roomChoose.id}
    $axios.post($endpoint.CheckRoomAvailableAtDate,roomCheckInfos).then((resp_check)=>{
      if (!resp_check.data.data){
        store.dispatch('booking_filter/saveRoomFilterData',bookForm)
        router.push({name:'book-apartment', props:{id:1}})
      }else {
        $alert.fire({
          title: 'Ooops!',
          text: resp_check.data.message,
          icon: 'error',
          confirmButtonColor:'#D62F2F',
          confirmButtonText: 'Compris'
        })
      }
    })
  }else {
    $alert.fire({
      title: 'Ooops!',
      text: 'Veuillez remplir les champs',
      icon: 'error',
      confirmButtonColor:'#D62F2F',
      confirmButtonText: 'Compris'
    })
  }
}
</script>

<template>
  <!-- SIDEBAR -->
  <div class="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s">
    <!-- booking form -->
    <div class="bg-color-csa uk-padding impx-padding-medium uk-margin-medium-bottom uk-box-shadow-medium">

      <div class="impx-hp-booking-form side-form uk-margin-bottom uk-margin-remove-top ">
        <h6 class="uk-heading-line uk-text-center uk-light uk-text-uppercase"><span>Disponibilité</span></h6>
        <div>
          <div class="uk-margin">
            <div class="uk-form-controls">
              <div class="uk-inline">
                <label class="uk-form-label">Entrée</label>
                <span class="uk-form-icon" data-uk-icon="icon: calendar"></span>
                <input class="uk-input booking-arrival uk-border-rounded" v-model="bookForm.arrival" type="date" placeholder="m/dd/yyyy">
              </div>
            </div>
          </div>
          <div class="uk-margin">
            <div class="uk-form-controls">
              <div class="uk-inline">
                <label class="uk-form-label">Depart</label>
                <span class="uk-form-icon" data-uk-icon="icon: calendar"></span>
                <input class="uk-input booking-departure uk-border-rounded" v-model="bookForm.departure" type="date" placeholder="m/dd/yyyy">
              </div>
            </div>
          </div>
          <div class="uk-margin">
            <div class="uk-form-controls uk-position-relative">
              <label class="uk-form-label" for="form-guest-select">Invités</label>
              <span class="uk-form-icon select-icon" data-uk-icon="icon: users"></span>
              <select class="uk-select uk-border-rounded" v-model="bookForm.guest" id="form-guest-select">
                <option value="1">1 personne</option>
                <option value="2">2 personnes</option>
                <option value="3">3 personnes</option>
                <option value="4">4 personnes</option>
              </select>
            </div>
          </div>
<!--          <div class="uk-margin">-->
<!--            <div class="uk-form-controls uk-position-relative">-->
<!--              <label class="uk-form-label" for="form-rooms-select">Rooms</label>-->
<!--              <span class="uk-form-icon select-icon" data-uk-icon="icon: album"></span>-->
<!--              <select class="uk-select uk-border-rounded" id="form-rooms-select">-->
<!--                <option value="">Please select...</option>-->
<!--                <option value="room_1">Single</option>-->
<!--                <option value="room_2">Double</option>-->
<!--                <option value="room_3">Primier</option>-->
<!--                <option value="room_4">Deluxe</option>-->
<!--              </select>-->
<!--            </div>-->
<!--          </div>-->
          <div>
            <label class="uk-form-label empty-label">&nbsp;</label>
            <button class="uk-button uk-width-1-1" @click="bookApartment">Reservé ici !</button>
          </div>
        </div>
      </div>
      <!-- booking form -->
    </div>
    <!-- SIDEBAR END -->

  </div>
</template>

<style scoped>

</style>